import app from 'app';

export default class RestrictionsController {
  static assignRestrictions(asset) {
    if (!Object.getOwnPropertyDescriptor(asset, '_restrictions')) {
      const hasRestrictions = RestrictionsController.hasRestrictions(
        asset.metadata.restrictions
      );
      const hasExpiration = RestrictionsController.hasExpiration(asset);

      asset.isContainsRestrictions = hasRestrictions || hasExpiration;
      asset._restrictions = RestrictionsController.getText(
        asset,
        hasRestrictions,
        hasExpiration
      );
    }
  }

  static hasRestrictions(restrictions) {
    return !_.isEmpty(_.trim(restrictions));
  }

  static hasExpiration(asset) {
    const expirationDate = asset.metadata.expirationDate;

    if (
      !_.isDefined(expirationDate) ||
      Object.getOwnPropertyDescriptor(
        tk.context._expirationExcludeProviders,
        asset.metadata.providerId
      )
    ) {
      return false;
    }

    // If expiration date is more than 10 years from now, it should not be displayed to the user at all.
    const deltaYears = app.moment(expirationDate).diff(app.moment(), 'years');
    return deltaYears < 10;
  }

  static _formatMessage(expirationDate) {
    const dateString = app.moment(expirationDate).format('MM/DD/YYYY');
    return app.culture.generic.EXPIRATION_DATE_RESTRICTIONS.format(dateString);
  }

  static getText(asset, hasRestrictions, hasExpiration) {
    const expirationDate = asset.metadata.expirationDate;
    let rv = asset.metadata.restrictions || '';

    if (app.assetType.isFairUse(asset) && !hasRestrictions) {
      rv = app.culture.generic.FAIR_USE_MESSAGE;
    } else if (hasRestrictions) {
      if (hasExpiration) {
        rv += '<br>' + RestrictionsController._formatMessage(expirationDate);
      }
    } else if (hasExpiration) {
      rv = RestrictionsController._formatMessage(expirationDate);
    }

    if (app.assetType.isEditorial(asset)) {
      rv +=
        (!_.isEmpty(rv) ? ' - ' : '') + app.culture.generic.FOR_EDITORIAL_USE;
    } else if (app.assetType.isCommercial(asset)) {
      rv +=
        (!_.isEmpty(rv) ? ' - ' : '') + app.culture.generic.FOR_COMMERCIAL_USE;
    }

    return rv;
  }
}
